import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Header from '../../../../components/Header';
import FooterTwo from '../../../../components/Footer';
import './ExtendedProfile.scss';
import PageBanner from '../../../../components/PageBanner';

import { mediaUrl } from '../../../../services/assetUrl';

const API_BASE = process.env.REACT_APP_DATABASEURL || '';

const ExtendedProfileSection = ({ section, isActive, onToggle }) => {
  const [activeCategory, setActiveCategory] = useState(section.rows[0]?.category);

  useEffect(() => {
    if (isActive && section.rows.length > 0) {
      setActiveCategory(section.rows[0].category);
    }
  }, [isActive, section]);

  const activeRow = section.rows.find(row => row.category === activeCategory) || section.rows[0];

  return (
    <div className={`ep-accordion-item ${isActive ? 'is-active' : ''}`}>
      <button 
        className="ep-accordion-header"
        onClick={onToggle}
        aria-expanded={isActive}
      >
        <div className="ep-accordion-header__left">
          <span className="ep-accordion-badge">{section.id}</span>
          <h2 className="ep-accordion-title">{section.title}</h2>
        </div>
        <div className="ep-accordion-header__right">
          <svg 
            className={`ep-accordion-icon ${isActive ? 'rotate' : ''}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      {isActive && (
        <div className="ep-accordion-body tab-fade-in p-6 bg-white">
          {/* Glass UI Tabs */}
          <div className="ep-tabs-container">
            {section.rows.map((row) => (
              <button
                key={row.category}
                onClick={() => setActiveCategory(row.category)}
                className={`ep-tab ${activeCategory === row.category ? 'ep-tab--active' : ''}`}
              >
                {row.category}
              </button>
            ))}
          </div>

          {/* Active Tab Content - Carousel */}
          <div className="ep-carousel">
            {activeRow?.links.map((link, linkIndex) => (
              <div key={linkIndex} className="ep-carousel-item">
                <span className="ep-carousel-item__year">{section.headers[linkIndex]}</span>
                {link.localHref ? (
                  <a
                    href={mediaUrl(link.localHref)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ep-carousel-item__link"
                    title="View PDF"
                  >
                    <svg className="ep-carousel-item__icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                    </svg>
                    <span>View PDF</span>
                  </a>
                ) : (
                  <span className="ep-carousel-item__link ep-carousel-item__link--disabled">
                    <span>#</span>
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ExtendedProfile = () => {
  const [extendedProfileData, setExtendedProfileData] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const sectionRefs = useRef({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}api/iqac-details/extended-profile`);
        const data = res?.data?.data?.data;
        if (active && Array.isArray(data)) {
          setExtendedProfileData(data);
          setActiveId((prev) => prev ?? data[0]?.id ?? null);
        }
      } catch (e) {
        // leave empty on failure
      }
    })();
    return () => { active = false; };
  }, []);

  const handleTabClick = (e, tableId) => {
    e.preventDefault();
    setActiveId(tableId);
    // Optionally, if on mobile, scroll to content area smooth
    if (window.innerWidth < 1024) {
       const contentEl = document.querySelector('.ep-content');
       if (contentEl) {
         contentEl.scrollIntoView({ behavior: 'smooth' });
       }
    }
  };

  return (
    <div className="ep-page">
      <Header />

      {/* Hero Section */}
      <PageBanner
        title="Extended Profile of the Institute"
        eyebrow="QUALITY ASSURANCE"
        subtitle="NAAC EXTENDED PROFILE DATA AND DVV CLARIFICATIONS"
      >
        <div style={{ marginTop: '32px' }}>
          <a
            href={mediaUrl("/view/iqac/naac/naac2/DVV-Clarification-Report-Extended-profile.pdf")}
            target="_blank"
            rel="noopener noreferrer"
            className="ep-hero__btn"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', backgroundColor: '#F6872A', color: 'white', borderRadius: '8px', fontWeight: 'bold', textDecoration: 'none' }}
          >
            <svg
              style={{ width: '20px', height: '20px' }}
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"></path>
            </svg>
            Download Full DVV Report (PDF)
          </a>
        </div>
      </PageBanner>

      {/* Main Content */}
      <main className="ep-main">
        <div className="ep-cinematic-container">

          {/* DVV Clarifications Horizontal Card */}
          <div className="ep-dvv-banner">
            <div className="ep-dvv-banner__content">
              <h2 style={{ color: '#ffffff' }}>DVV Clarifications</h2>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Access the complete Data Validation and Verification (DVV) report for the Extended Profile of the Institute.</p>
            </div>
            <a
              href={mediaUrl("/view/iqac/naac/naac2/DVV-Clarification-Report-Extended-profile.pdf")}
              target="_blank"
              rel="noopener noreferrer"
              className="ep-dvv-banner__btn"
            >
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
              </svg>
              Download PDF
            </a>
          </div>

          {/* Accordion Layout */}
          <div className="ep-accordion-list flex flex-col gap-4">
            {extendedProfileData.map((section) => (
              <ExtendedProfileSection 
                key={`section-${section.id}`} 
                section={section} 
                isActive={activeId === section.id}
                onToggle={(e) => handleTabClick(e, activeId === section.id ? null : section.id)}
              />
            ))}
          </div>

        </div>
      </main>

      <FooterTwo />
    </div>
  );
};

export default ExtendedProfile;
